import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  isLoadingPredictiveMaintenance: false,
  isLoadingDemandCleaning: false,
  isLoadingBurnTimeData: false,
  isLoadingSecurityMonitoring: false,
};

export const editPredictiveMaintenance: any = createAsyncThunk(
  "content/editPredictiveMaintenance",
  async ({ payload }: any) => {
    const res = await axios.put(
      `/slpapp/AlertConfiguration/PredicitiveMaintenance`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await res?.data?.data;
    return data;
  }
);

export const editOnDemandCleaning: any = createAsyncThunk(
  "content/editOnDemandCleaning",
  async ({ payload }: any) => {
    const res = await axios.put(
      `/slpapp/AlertConfiguration/OnDemandCleaning`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await res?.data?.data;
    return data;
  }
);

export const editBurnTimeData: any = createAsyncThunk(
  "content/editBurnTimeData",
  async ({ payload }: any) => {
    const res = await axios.put(
      `/slpapp/AlertConfiguration/BurnTime`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await res?.data?.data;
    return data;
  }
);

export const postSecurityMonitoring: any = createAsyncThunk(
  "content/editSecurityMonitoring",
  async (payload) => {
    const res = await axios.post(
      `/slpapp/SecurityMonitoringConfiguration`,
      payload
    );
    const data = await res.data;

    return data;
  }
);

export const alertConfigurationSlice = createSlice({
  name: "alertConfiguration",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(editPredictiveMaintenance.pending, (state) => {
      state.isLoadingPredictiveMaintenance = true;
    });
    builder.addCase(editPredictiveMaintenance.fulfilled, (state, action) => {
      state.isLoadingPredictiveMaintenance = false;
    });
    builder.addCase(editPredictiveMaintenance.rejected, (state, action) => {
      state.isLoadingPredictiveMaintenance = false;
      state.error = action.error.message;
    });

    builder.addCase(editOnDemandCleaning.pending, (state) => {
      state.isLoadingDemandCleaning = true;
    });
    builder.addCase(editOnDemandCleaning.fulfilled, (state, action) => {
      state.isLoadingDemandCleaning = false;
    });
    builder.addCase(editOnDemandCleaning.rejected, (state, action) => {
      state.isLoadingDemandCleaning = false;
      state.error = action.error.message;
    });

    builder.addCase(editBurnTimeData.pending, (state) => {
      state.isLoadingBurnTimeData = true;
    });
    builder.addCase(editBurnTimeData.fulfilled, (state, action) => {
      state.isLoadingBurnTimeData = false;
    });
    builder.addCase(editBurnTimeData.rejected, (state, action) => {
      state.isLoadingBurnTimeData = false;
      state.error = action.error.message;
    });

    builder.addCase(postSecurityMonitoring.pending, (state) => {
      state.isLoadingSecurityMonitoring = true;
    });
    builder.addCase(postSecurityMonitoring.fulfilled, (state, action) => {
      state.isLoadingSecurityMonitoring = false;
    });
    builder.addCase(postSecurityMonitoring.rejected, (state, action) => {
      state.isLoadingSecurityMonitoring = false;
      state.error = action.error.message;
    });
  },
});

export default alertConfigurationSlice.reducer;
